


import React from 'react';
import { Table } from '@tanstack/react-table';

interface PaginationControlsProps {
  table: Table<any>;
}

const PaginationControlsView: React.FC<PaginationControlsProps> = ({ table }) => {
  const pageCount = table.getPageCount();
  const currentPage = table.getState().pagination.pageIndex;
  return (
    <div className="brokerage-ui">
      <style>{`
        .brokerage-ui { --pg-size:28px; --pg-radius:8px; --pg-border:#e6ebf2; --pg-blue:#2563eb; --pg-text:#0f172a; --pg-icon:#475569; --pg-icon-disabled:#cbd5e1; }
        .brokerage-ui .panel-pager{padding:10px 14px;background:#fff;gap:10px;flex-wrap:wrap}
        .brokerage-ui .panel-pager > span{color:#334155;font-size:12.5px;flex:1 1 auto;min-width:180px}
        .brokerage-ui .pageSizeSelect1{height:var(--pg-size);padding:2px 26px 2px 10px;border:1px solid var(--pg-border);border-radius:var(--pg-radius);background:#fff;box-shadow:none;font-size:12px;line-height:1;width:auto;min-width:88px}
        .brokerage-ui .pager-controls{display:inline-flex;align-items:center;gap:6px}
        .brokerage-ui .pager-chevron{width:var(--pg-size);height:var(--pg-size);border-radius:var(--pg-radius);border:1px solid var(--pg-border);background:#fff;display:inline-flex;align-items:center;justify-content:center;padding:0;line-height:1}
        .brokerage-ui .pager-chevron i{font-size:14px;color:var(--pg-icon)}
        .brokerage-ui .pager-chevron:disabled i{color:var(--pg-icon-disabled)}
        .brokerage-ui .pager-chip{min-width:var(--pg-size);height:var(--pg-size);padding:0 8px;border-radius:var(--pg-radius);border:0;background:#fff;color:var(--pg-text);font-weight:600;font-size:12px;display:inline-flex;align-items:center;justify-content:center;line-height:1}
        .brokerage-ui .pager-chip.active{background:var(--pg-blue);color:#fff}
      `}</style>

      <div className="panel-pager border-top px-4 py-3 d-flex align-items-center justify-content-between">
        <span>
          Page {currentPage + 1} of {pageCount}
        </span>

        <div className="d-flex align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            <span>Rows per page:</span>
            <select
              className="form-select pageSizeSelect1"
              value={table.getState().pagination.pageSize}
              onChange={(e) => { table.setPageSize(Number(e.target.value)); table.setPageIndex(0); }}
            >
              {[5, 10, 20, 50, 100].map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="pager-controls">
            <button className="pager-chevron" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
              <i className="bi bi-chevron-left" />
            </button>

            <button className="pager-chip active">{currentPage + 1}</button>

            <button className="pager-chevron" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaginationControlsView;

















// /* ===== EXACT SMALL PAGER (like your first screenshot) ===== */
// .brokerage-ui {
//   --pg-size: 28px;          /* button height/width (btn-sm) */
//   --pg-radius: 8px;         /* rounded corners */
//   --pg-border: #e6ebf2;     /* thin border */
//   --pg-blue: #2563eb;       /* active page blue */
//   --pg-text: #0f172a;       /* dark text */
//   --pg-icon: #475569;       /* chevron color */
//   --pg-icon-disabled: #cbd5e1;
// }

// /* keep pager clean & compact */
// .brokerage-ui .panel-pager {
//   padding: 10px 14px !important;
//   background: #fff !important;
// }

// /* right side cluster layout */
// .brokerage-ui .panel-pager .d-flex.flex-wrap { gap: 10px !important; }

// /* “Rows per page” — small pill */
// .brokerage-ui .panel-pager .pageSizeSelect1 {
//   height: var(--pg-size) !important;
//   padding: 2px 26px 2px 10px !important;
//   border: 1px solid var(--pg-border) !important;
//   border-radius: var(--pg-radius) !important;
//   background: #fff !important;
//   box-shadow: none !important;
//   font-size: 12px !important;
//   line-height: 1 !important;
//   width: 34% !important;
// }

// /* group: no outer frame */
// .brokerage-ui .panel-pager .pager-controls {
//   display: inline-flex !important;
//   align-items: center !important;
//   gap: 6px !important;
//   background: transparent !important;
//   border: 0 !important;
//   padding: 0 !important;
//   box-shadow: none !important;
//   border-radius: 0 !important;
// }

// /* chevrons: small, thin border, white bg */
// .brokerage-ui .panel-pager .pager-chevron {
//   width: var(--pg-size) !important;
//   height: var(--pg-size) !important;
//   border-radius: var(--pg-radius) !important;
//   border: 1px solid var(--pg-border) !important;
//   background: #fff !important;
//   display: inline-flex !important;
//   align-items: center !important;
//   justify-content: center !important;
//   padding: 0 !important;
//   line-height: 1 !important;
//   box-shadow: none !important;
// }
// .brokerage-ui .panel-pager .pager-chevron i {
//   font-size: 14px !important;
//   color: var(--pg-icon) !important;
// }
// .brokerage-ui .panel-pager .pager-chevron:focus { box-shadow: none !important; }
// .brokerage-ui .panel-pager .pager-chevron:disabled i { color: var(--pg-icon-disabled) !important; }
// .brokerage-ui .panel-pager .pager-chevron:disabled { opacity: 1 !important; cursor: not-allowed !important; }

// /* page number: compact blue chip, NO border */
// .brokerage-ui .panel-pager .pager-chip {
//   min-width: var(--pg-size) !important;
//   height: var(--pg-size) !important;
//   padding: 0 8px !important;
//   border-radius: var(--pg-radius) !important;
//   border: 0 !important;                 /* <-- remove border */
//   background: #fff !important;
//   color: var(--pg-text) !important;
//   font-weight: 600 !important;
//   font-size: 12px !important;
//   display: inline-flex !important;
//   align-items: center !important;
//   justify-content: center !important;
//   line-height: 1 !important;
// }
// .brokerage-ui .panel-pager .pager-chip.active {
//   background: var(--pg-blue) !important;
//   color: #fff !important;
// }

// /* left label tone/sizing */
// .brokerage-ui .panel-pager > span {
//   color: #334155 !important;
//   font-size: 12.5px !important;
// }

// /* kill any residual bootstrap focus/hover frames */
// .brokerage-ui .panel-pager .pager-chevron:hover,
// .brokerage-ui .panel-pager .pager-chip:hover,
// .brokerage-ui .panel-pager .pageSizeSelect1:hover {
//   filter: none !important;
//   box-shadow: none !important;
// }
